import { createAction, props } from '@ngrx/store';
import { AlertsState } from '../states/alertsState';

export const addToAlerts = createAction('[Alerts] Add', props<AlertsState>());
